import { Appointment } from '@/types/appointments.types';
import { AppointmentType } from '@/types/enums/appointments.enum';
import { FacilityType } from '@/types/enums/facility-type.enum';
import { Professional } from '@/types/main.types';

export function getProfessionalProfilePath(professional?: Pick<Professional, 'slug'>): string | undefined {
  return professional?.slug ? `/profissionais/${professional.slug}/` : undefined;
}

export function getPartnerProfilePath({ type, partner }: Pick<Appointment, 'type' | 'partner'>): string | undefined {
  const slug = partner.facility?.slug;

  if (!slug) {
    return undefined;
  }

  const isCollectPoint = type === AppointmentType.LABORATORIAL && partner.facility.type !== FacilityType.MAIN;

  return isCollectPoint ? `/laboratorios/${slug}/` : `/parceiros/${slug}/`;
}
